const TokenType = {
    KEYWORD: 'KEYWORD',
    IDENTIFIER: 'IDENTIFIER',
    NUMBER: 'NUMBER',
    STRING: 'STRING',
    OPERATOR: 'OPERATOR',
    PUNCTUATION: 'PUNCTUATION',
    EOF: 'EOF'
};

const Keywords = {
    PROGRAM_START: 'PROGRAM_START', // hi
    PROGRAM_END: 'PROGRAM_END',     // bye
    PRINT: 'PRINT',                 // say
    VARIABLE: 'VARIABLE',           // assume
    UNTIL: 'UNTIL',                 // until
    IF: 'IF',                       // if
    ELSE: 'ELSE',                   // else
    FOR: 'FOR',                     // for loop
    BREAK: 'BREAK',                 // break
    CONTINUE: 'CONTINUE',           // continue
    TRUE: 'TRUE',                   // true
    FALSE: 'FALSE',                 // false
    AND: 'AND',                     // and
    OR: 'OR',                       // or
    LENGTH: 'LENGTH',               // length
    INPUT: 'INPUT'                  // input
};

module.exports = { TokenType, Keywords };
